import React from 'react';
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl';
import { NotificationBannerType } from '../notification-banner';
import { PictogramIcon } from 'dig-components/icons';
import { WarningPictogram } from 'dig-components/dist/icons/src';
import { Banner } from 'dig-components/banner';
import styles from './api-setting.scss';
import { Text } from 'dig-components/typography';
import Spacer, { SpacerSize } from 'hellospa/foundation/spacing/spacer';
import { trackHeapCustomEvent } from 'common/utils/heap';

function LegacyKeyWarningBanner() {

  return (
    <Banner
      variant='rich'
      type={NotificationBannerType.Warning}
      withLeftPictogram={<PictogramIcon src={WarningPictogram} />}
    >
      <Banner.Message>
        <div>
          <Text size='large' isBold>
            <FormattedMessage
              id=''
              description='Warning banner, API settings page, title above a section that displays description.'
              defaultMessage='Update API key' />
          </Text>
          <Spacer top={SpacerSize.SM} />
          <FormattedHTMLMessage
            id=''
            description='Warning banner, API settings page, summary above a section that displays detail description.'
            defaultMessage='We upgraded the security of our API keys. Please follow the steps below to
            replace your existing legacy key with a newly-generated one by <strong>July 1st, 2022</strong>:' />
          <ol className={styles.apiSettingOrderList}>
            <li>
              <FormattedMessage
                id=''
                description='Warning banner, Step 1 for migrating legacy API key.'
                defaultMessage='Generate a new key' />
            </li>
            <li>
              <FormattedMessage
                id=''
                description='Warning banner, Step 2 for migrating legacy API key.'
                defaultMessage='Replace the legacy key in your codebase with the new key' />
            </li>
            <li>
              <FormattedMessage
                id=''
                description='Warning banner, Step 3 for migrating legacy API key.'
                defaultMessage='Make the new key primary to verify callback events' />
            </li>
            <li>
              <FormattedMessage
                id=''
                description='Warning banner, Step 4 for migrating legacy API key.'
                defaultMessage='Delete the legacy key' />
            </li>
          </ol>
          <br />
          <FormattedMessage
            id=''
            description='Warning banner, Step 4 for migrating legacy API key.'
            defaultMessage='For full details, see our <l>step-by-step guide</l>.'
            values={{
              /* eslint-disable-next-line react/display-name */
              l: (...chunks: string[]) => <a
                href='/api/multiKeyRotationGuide'
                data-qa-ref="api-key-guide-link"
                target='_blank'
                onClick={() => trackHeapCustomEvent('api_key_guide_link_click')}
              >
                {chunks}
              </a>,
            }} />
        </div>
      </Banner.Message>
    </Banner>
  );
}

export default LegacyKeyWarningBanner;
